import Vue from 'vue';
import VisitGuideMapPage from './visit-guide-map-page.vue';

window.addEventListener("DOMContentLoaded", (e) => {
  const visitGuideWrapper = document.getElementById('visit-guide-map');
  const themeGroups = JSON.parse(visitGuideWrapper.dataset.themeGroups);

  new Vue({
    el: '#visit-guide-map',
    components: { VisitGuideMapPage },
    data: { themeGroups: themeGroups },
    template: '<VisitGuideMapPage :themeGroups=themeGroups />',
  });
});